@if (!pdf) {
    @defer (on viewport; prefetch on idle) {
        <ng-container [ngTemplateOutlet]="visualizationContent"></ng-container>
    } @placeholder {
        <div fxLayout="column" class="full-width">
            <dsn-skeleton-loader
                [width]="'100%'"
                [height]="'400px'"
                [type]="'rectangle'"
            ></dsn-skeleton-loader>
        </div>
    }
} @else {
    <ng-container [ngTemplateOutlet]="visualizationContent"></ng-container>
}

<ng-template #visualizationContent>
    <div
        class="report-visualization-component"
        [fxLayout]="isMobile() ? 'column' : 'row'"
        [class]="{ 'gap-12': !isMobile() }"
        fxFlex
    >
        <div
            class="report-visualization-component__area"
            [class.gap-16]="!pdf"
            [class.gap-4]="pdf"
            [class.bordered]="!pdf"
            fxLayout="column"
            fxFlex
        >
            <div
                class="report-visualization-component__area__header gap-16"
                fxLayout="row"
                fxLayoutAlign="start center"
            >
                <h1
                    class="color-text-primary"
                    [class.text-14-semi-bold]="!pdf"
                    [class.text-10-semi-bold]="pdf"
                >
                    {{ visualization.props.name }}
                </h1>
                <span fxFlex></span>
                @if (
                    visualization.props?.component?.name ===
                        "TABLE_VISUALIZATION" && isMobile()
                ) {
                    <dsn-button
                        [label]="'Expandir Tabela'"
                        [type]="'secondary'"
                        [size]="'small'"
                        [disabled]="false"
                        [iconLeft]="'fa-solid fa-expand'"
                        (click)="onExpand()"
                    ></dsn-button>
                }
                @if (previewMode) {
                    <dsn-button
                        [rocketBadge]="
                            accountingPlanService.features?.['IAContador'] ||
                            loading
                                ? false
                                : true
                        "
                        [label]="'Analisar com a IA'"
                        [type]="'tertiary'"
                        [size]="'small'"
                        [iconLeftCustom]="'/images/logos/nanda-icon-logo.svg'"
                        [fontWeight]="'bold'"
                        [typeButton]="'button'"
                        [iconSizeCustom]="'large'"
                        [disabled]="loading"
                        (click)="onAnalyzeWithIA()"
                    ></dsn-button>
                }
            </div>
            <div class="gap-16" fxLayout="column">
                @if (this.isMobile()) {
                    <div style="min-height: 400px">
                        <app-visualization
                            [loading]="loading"
                            [visualization]="visualization"
                            [company]="company"
                            [options]="report.options"
                            (handlePoints)="onPointsChange($event)"
                            style="height: 100%"
                            [isAccumulated]="isAccumulated"
                        ></app-visualization>
                    </div>

                    @if (
                        visualization.props?.component?.name !==
                        "TABLE_VISUALIZATION"
                    ) {
                        <dsn-expand-collapse
                            [isExpanded]="true"
                            icon="fa-solid fa-compass"
                            label="Explorar Indicador"
                            type="indicators"
                        >
                            <app-report-visualization-explore
                                [loading]="loading"
                                [report]="report"
                                [hasPoints]="hasValiData()"
                                [company]="company"
                                [visualization]="visualization"
                                (handleSelectVisualizationDrillDown)="
                                    onSelectVisualizationDrillDown($event)
                                "
                            ></app-report-visualization-explore>
                        </dsn-expand-collapse>
                    }
                } @else {
                    <div
                        fxLayout="row"
                        class="gap-24"
                        [style]="
                            pdf ? 'min-height: 300px' : 'min-height: 400px'
                        "
                    >
                        <div
                            style="min-height: 285px"
                            [fxFlex]="
                                visualization.props?.component?.name !==
                                    'TABLE_VISUALIZATION' && !pdf
                                    ? 60
                                    : 100
                            "
                        >
                            <app-visualization
                                [loading]="loading"
                                [visualization]="visualization"
                                [company]="company"
                                [options]="report.options"
                                style="height: 100%"
                                (handlePoints)="onPointsChange($event)"
                                [isAccumulated]="isAccumulated"
                            ></app-visualization>
                        </div>

                        @if (!pdf) {
                            @if (
                                visualization.props?.component?.name !==
                                "TABLE_VISUALIZATION"
                            ) {
                                <div
                                    class="full-height"
                                    fxFlex="40"
                                    style="
                                        border-radius: var(--border-radius-8);
                                        overflow: hidden;
                                    "
                                >
                                    <dsn-expand-collapse
                                        [isExpanded]="true"
                                        [shadow]="true"
                                        icon="fa-solid fa-compass"
                                        label="Explorar"
                                        type="indicators"
                                        [disabled]="true"
                                        style="
                                            height: 91%;
                                            display: flex;
                                            flex-direction: column;
                                        "
                                        [isFullHeight]="true"
                                    >
                                        <app-report-visualization-explore
                                            style="height: 100%"
                                            [loading]="loading"
                                            [hasPoints]="hasValiData()"
                                            [report]="report"
                                            [company]="company"
                                            [visualization]="visualization"
                                            (handleSelectVisualizationDrillDown)="
                                                onSelectVisualizationDrillDown(
                                                    $event
                                                )
                                            "
                                        ></app-report-visualization-explore>
                                    </dsn-expand-collapse>
                                </div>
                            }
                        }
                    </div>
                }

                @if (!pdf) {
                    @if (isMobile() && contact?.props?._id !== "convidadoId") {
                        <div
                            class="report-visualization-component__area__divider"
                        ></div>
                    }

                    @if (mainVisualization.note) {
                        <dsn-expand-collapse
                            [isExpanded]="true"
                            [icon]="'fas fa-sticky-note'"
                            [label]="'Notas da Contabilidade'"
                            [type]="'notes'"
                            [id]="'note-' + mainVisualization.note.props._id"
                        >
                            <app-report-visualization-note
                                [visualization]="mainVisualization"
                            ></app-report-visualization-note>
                        </dsn-expand-collapse>
                    }

                    <app-visualization-posts
                        [company]="company"
                        [report]="report"
                        [options]="report.options"
                        [visualization]="visualization"
                        [previewMode]="previewMode"
                    ></app-visualization-posts>
                }
            </div>
        </div>
    </div>
</ng-template>
